<template>
    <!-- 厂家端归档告警历史页面 -->
  <div class="adminAlarm alarmSNew archive-history">
    <div class="section" style="box-shadow: none">
      <!-- 搜索栏：左侧（返回按钮、月份选择器、告警类型筛选），右侧（搜索、导出按钮） -->
      <div class="search">
        <div class="left">
          <el-button class="btn-back" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            {{ $t("alarm.back") }}
          </el-button>
          <div class="datePreNext">
            <span class="date-icon"></span>
            <!-- 上一月 -->
            <span class="date-btn date-pre" @click="toPreMonth"></span>
            <!-- 日期选择器 -->
            <el-date-picker v-model="chartDate" type="month" class="datepicker" :editable="false" :clearable="false"
              popper-class="select-date" :picker-options="pickerMonthOptions" align="center"
              ref="dateMonth"></el-date-picker>
            <!-- 下一月 -->
            <span class="date-btn date-next" @click="toNextMonth"></span>
          </div>
          <span class="search-label">{{ $t("alarm.Alarm_Type") }}</span>
          <el-select
            v-model="search.level"
            :placeholder="$t('header.pleaseSelect')"
            size="small"
            clearable
            @change="getData(true)"
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="item in level"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
        </div>
        <!-- 右侧操作区：搜索按钮、导出按钮、搜索弹框 -->
        <div class="right">
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <!-- <el-button
            type="text"
            class="button-export"
            :disabled="exportReportMonthLoad"
            @click="exportReportMonth()"
            >{{ $t("alarm.exportArchive") }}</el-button
          > -->
          <div class="search-alert" v-if="showSearch">
            <div class="searchDiv">
              <el-input
                class="searchAll"
                ref="iptFocus"
                v-model.trim="search.search"
                @keyup.enter.native="handleSearch"
                placeholder="PN"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="handleSearch">{{
                $t("recharge.Search")
              }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{
                $t("rate.cancel")
              }}</span>
            </div>
          </div>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <div class="batch-alert" v-show="selectedAlarm.length">
          <!-- 当前选中条数 -->
          <span class="batch-total">
            {{
              `${$t("alarm.curSelected")} ${selectedAlarm.length} ${$t(
                "alarm._Data"
              )}`
            }}
          </span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 删除 -->
              <span class="btn" @click="detelealarm(selectedAlarm)">
                {{ $t("device.delete") }}
                <i class="ico ico-clear"></i>
              </span>
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{
              $t("rate.cancel")
            }}</span>
          </div>
        </div>
      </div>

      <!-- 归档告警列表表格 -->
      <el-table
        :data="alarmlist"
        border
        stripe
        height="100%"
        :row-style="{ height: 0 }"
        :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        v-loading="alarmloading"
        element-loading-spinner="el-icon-loading"
        @selection-change="changeFun"
        class="tablemain tableloding"
        :empty-text="$t('account.nodata')"
        ref="multipleSnTable"
        :cell-class-name="addClass"
      >
        <el-table-column type="selection" fixed></el-table-column>
        <el-table-column
          prop="gts"
          fixed
          min-width="180px;"
          :label="$t('alarm.Occurrence_time')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="level"
          min-width="145px;"
          :label="$t('alarm.Alarm_Type')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div
              :class="`background-${level[scope.row.level].name}`"
              style="border-radius: 5px; margin: 0 20px"
            >
              <span
                :class="`radius-${level[scope.row.level].name}`"
                style="
                  width: 8px;
                  height: 8px;
                  border-radius: 8px;
                  display: inline-block;
                  margin-right: 5px;
                "
              ></span>
              <span
                v-if="scope.row.level !== undefined"
                :class="`color-${level[scope.row.level].name}`"
                >{{ level[scope.row.level].label }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="110px"
          prop="handle"
          :label="$t('alarm.Alarm_Status')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.handle.class == 'untreated'"
              style="color: #ec9630"
              >{{ scope.row.handle.label }}</span
            >
            <span v-else style="color: rgba(255, 255, 255, 0.3)">{{
              scope.row.handle.label
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100px;"
          :label="$t('alarm.Alarm_Code')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.code || '--'">{{
              scope.row.code || "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="desc"
          min-width="130px;"
          :label="$t('alarm.Alarm_Describe')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="sn"
          min-width="150px;"
          :label="$t('alarm.Device_SN')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              class="redirect"
              @click="enterDevice(scope.row)"
              :title="scope.row.deviceSn || scope.row.sn || '--'"
              >{{ scope.row.deviceSn || scope.row.sn || "--" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="pn"
          min-width="130px;"
          :label="$t('alarm.Device_PN')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="devaddr"
          min-width="85px;"
          :label="$t('alarm.device_address')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('alarm.Operation')"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('alarm.details')"
              @click="checkalarm(scope.row)"
            >
              <i class="iconfont icon-a-mingchenggaojingrizhi2"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('alarm.deletes')"
              @click="detelealarm([scope.row])"
            >
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="tablebottom">
        <span class="" style="margin-left: 16px"></span>
        <el-pagination
          class="pagination"
          background
          @size-change="getData(true)"
          @current-change="() => getData()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color: #ffffff; padding-left: 15px"
            >{{ $t("device.pageSize") }} :</span
          >
        </el-pagination>
      </div>
    </div>
    <!-- 告警详情弹框 -->
    <deletesalarm-dialog
      :title="$t('alarm.alarmDetails')"
      :width="
        this.$lang.currentLang == 'zh_CN' ||
        this.$lang.currentLang == 'en_US' ||
        this.$lang.currentLang == 'en_ID'
          ? '460px'
          : '560px'
      "
      :class="{
        showDialog: showcheckalarmdialog,
        hideDialog: !showcheckalarmdialog,
      }"
      :visible.sync="showcheckalarmdialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="checkalarm">
          <div class="alarmdetails" style="color: #30d096; font-size: 16px">
            {{ $t("alarm.alarmInfo") }}
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Occurrence_time") }}</span>
            <span>{{ checkData.gts }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.endtime") }}</span>
            <span>{{ checkData.cts || "--" }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Status") }}</span>
            <span
              v-if="checkData.handle.class == 'untreated'"
              style="color: #ec9630"
              >{{ checkData.handle.label }}</span
            >
            <span v-else style="color: rgba(255, 255, 255, 0.3)">{{
              checkData.handle.label
            }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Type") }}</span>
            <div
              :class="`background-${level[checkData.level].name}`"
              style="border-radius: 5px; padding: 0 10px"
            >
              <span
                :class="`radius-${level[checkData.level].name}`"
                style="
                  width: 8px;
                  height: 8px;
                  border-radius: 8px;
                  display: inline-block;
                  margin-right: 5px;
                "
              ></span>
              <span
                v-if="checkData.level !== undefined"
                :class="`color-${level[checkData.level].name}`"
                >{{ level[checkData.level].label }}</span
              >
              <span v-else>{{ "--" }}</span>
            </div>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Code") }}</span>
            <span>{{ checkData.code }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Describe") }}</span>
            <span>
              <el-tooltip
                :content="checkData.desc"
                placement="top"
                effect="dark"
              >
                <span class="ellipsis-span">
                  {{ checkData.desc }}
                </span>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="checkalarm">
          <div class="alarmdetails" style="color: #30d096; font-size: 16px">
            {{ $t("alarm.alarmDevice") }}
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Device_Type") }}</span>
            <span>
              <span>{{
                brand[checkData.brand == fieldUndefined ? 10 : checkData.brand]
                  .label
              }}</span>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Device_SN") }}</span>
            <span>
              <el-tooltip :content="checkData.deviceSn || checkData.sn" placement="top" effect="dark">
                <span class="ellipsis-span">
                  {{ checkData.deviceSn || checkData.sn }}
                </span>
              </el-tooltip>
              <i
                @click="copy(checkData.deviceSn || checkData.sn)"
                style="color: #33ffb6; padding-left: 10px"
                class="iconfont icon-biaogegongneng_fuzhi"
              ></i>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.device_alias") }}</span>
            <span>
              <el-tooltip
                :content="checkData.alias || checkData.sn"
                placement="top"
                effect="dark"
              >
                <span class="ellipsis-span">
                  {{ checkData.alias || checkData.sn || "--" }}
                </span>
              </el-tooltip>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.device_address") }}</span>
            <span>{{ checkData.devaddr }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Device_PN") }}</span>
            <span
              >{{ checkData.pn
              }}<i
                @click="copy(checkData.pn)"
                style="color: #33ffb6; padding-left: 10px"
                class="iconfont icon-biaogegongneng_fuzhi"
              ></i
            ></span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.User") }}</span>
            <span>
              <el-tooltip
                :content="checkData.usr"
                placement="top"
                effect="dark"
              >
                <span
                  style="color: #30d096; cursor: pointer"
                  @click="enterDevice(checkData)"
                  class="ellipsis-span"
                >
                  {{ checkData.usr }}
                </span>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="deletfotter" style="text-align: center; margin-top: 28px">
          <button class="btn btn-light" @click="showcheckalarmdialog = false">
            {{ $t("alarm.Close") }}
          </button>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警确认弹框 -->
    <deletesalarm-dialog
      :title="$t('alarm.deletes')"
      :class="{
        showDialog: showdeletesalarmdialog,
        hideDialog: !showdeletesalarmdialog,
      }"
      :visible.sync="showdeletesalarmdialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
          <span class="contentdelete" style="width: 100%; text-align: left">{{
            $t("alarm.delete_alarm")
          }}</span>
        </div>
        <div class="disabledescr">
          <span style="width: 100%; text-align: left; margin-top: 28px">{{
            $t("account.notRecovered")
          }}</span>
        </div>
        <div class="deletfotter" style="text-align: right; margin-top: 28px">
          <button
            class="btn btn-dark"
            style="margin-right: 10px"
            @click="configdelete"
          >
            {{ $t("alarm.Confirm") }}
          </button>
          <el-button class="btn btn-light" @click="closeDialog">
            {{ $t("alarm.Cancel") }}
          </el-button>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警成功提示弹框 -->
    <deletesalarm-dialog
      :title="$t('project.delResults')"
      :visible.sync="delAlarmSucVisible"
      :class="{
        showDialog: delAlarmSucVisible,
        hideDialog: !delAlarmSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t("project.delSuc") }}</span>
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="delAlarmSucVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警失败提示弹框 -->
    <deletesalarm-dialog
      :title="$t('project.delResults')"
      :visible.sync="delAlarmFailVisible"
      :class="{
        showDialog: delAlarmFailVisible,
        hideDialog: !delAlarmFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ alarmTipMsg }}</span>
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="delAlarmFailVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 导出弹框：选择月份及设备筛选条件 -->
    <deletesalarm-dialog
      :title="$t('report.Export_alarm')"
      :visible.sync="exportDialog"
      :class="{ showDialog: exportDialog, hideDialog: !exportDialog }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox searchDialog">
          <span class="search-label">{{ $t("actionLog.date") }}</span>
          <el-date-picker v-model="dialogDateValue" type="month" class="datepicker" :editable="false" :clearable="false"
            popper-class="select-date" :picker-options="dialogPickerMonthOptions" align="center"
            ref="dateMonthPicker"></el-date-picker>
          <span class="search-label">{{ $t("alarm.Device_SN") }}</span>
          <el-input style="width: 100%" v-model.trim="dialogForm.sn" class="dialog-input" clearable></el-input>
          <span class="search-label">{{ $t("alarm.Device_PN") }}</span>
          <el-input style="width: 100%" v-model.trim="dialogForm.pn" class="dialog-input" clearable></el-input>
          <span class="search-label">{{ $t("device.device_address") }}</span>
          <el-input style="width: 100%" v-model.trim="dialogForm.devaddr" class="dialog-input" clearable></el-input>
          <span class="search-label">{{ $t("device.device_code1") }}</span>
          <el-input style="width: 100%" v-model.trim="dialogForm.devcode" class="dialog-input" clearable></el-input>
        </div>
        <div class="showoperate">
          <div class="deletfotter" style="text-align: right; margin-top: 28px">
            <el-button
              class="btn btn-light"
              style="margin-right: 10px"
              @click="closeExportDialog"
            >
              {{ $t("alarm.Cancel") }}
            </el-button>
            <el-button
              class="btn btn-dark"
              @click="confirmClick"
              :loading="confirmLoading"
            >
              {{ $t("alarm.Confirm") }}
            </el-button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 导出任务列表弹框：查看导出文件状态及下载 -->
    <deletesalarm-dialog
      :title="$t('report.Export_alarm')"
      :visible.sync="exportListDialog"
      :class="{ showDialog: exportListDialog, hideDialog: !exportListDialog }"
      width="1200px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox" style="height: 750px">
          <el-table
            :data="exportList"
            border
            stripe
            height="500px"
            :row-style="{ height: 0 }"
            :cell-style="{ padding: 0 }"
            :header-cell-style="{
              background: 'rgb(65, 80, 90)',
              color: '#ffffff',
            }"
            element-loading-spinner="el-icon-loading"
            class="tablemain tableloding"
            :empty-text="$t('account.nodata')"
            :cell-class-name="addClass"
          >
            <el-table-column
              prop="filename"
              min-width="150px;"
              :label="$t('alarmNew.fileName')"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="status"
              :label="$t('alarmNew.fileStatus')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">{{
                  $t("alarmNew.can")
                }}</span>
                <span v-else>{{ $t("alarmNew.no") }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="size"
              :label="$t('alarmNew.fileSize')"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="gts"
              min-width="85px;"
              :label="$t('account.createTime')"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="progress"
              :label="$t('alarmNew.progress')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.progress + "%" }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('alarm.Operation')"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="operation"
                  :title="$t('firmware.downloadFirmware')"
                  @click="exportDownLoad(scope.row)"
                  :disabled="!parseFloat(scope.row.size)"
                  v-if="scope.row.status == 1"
                >
                  <i class="el-icon-download"></i>
                </el-button>
                <el-button
                  type="text"
                  class="operation"
                  :title="$t('device.refresh')"
                  @click="queryExportList()"
                  v-else
                >
                  <i class="iconfont icon-refresh"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="tablebottom">
            <span class="" style="margin-left: 16px"></span>
            <el-pagination
              class="pagination"
              background
              @size-change="queryExportList(true)"
              @current-change="() => queryExportList()"
              :current-page.sync="dialogPagination.currentPage"
              :page-sizes="[10, 15, 20, 30, 50]"
              :page-size.sync="dialogPagination.pagesize"
              layout="slot, sizes, total, pager, prev, next, jumper"
              :total="dialogPagination.total"
              popper-class="select-page"
            >
              <span style="color: #ffffff; padding-left: 15px"
                >{{ $t("device.pageSize") }} :</span
              >
            </el-pagination>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
  </div>
</template>
<script>
import deletesalarmDialog from "@/components/dialognew";
import { mapGetters } from "vuex";
import { i18n } from "@/i18n";
export default {
  components: {
    deletesalarmDialog,
  },
  data() {
    // 初始化日期为当天零点，用作月份选择器默认值
    const end = new Date();
    end.setHours(0, 0, 0, 0);
    const start = new Date(end.getFullYear(), end.getMonth(), 1);
    return {
      // 导出按钮禁用状态（列表无数据时禁用）
      exportReportMonthLoad: false,
      // 权限控制：是否隐藏功能按钮
      disPermissionsLogo: sessionStorage.getItem("disPermissionsLogo")
        ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
        : false,
      // 权限控制：用户拥有的按钮权限列表
      btnList: sessionStorage.getItem("buttonArr")
        ? JSON.parse(sessionStorage.getItem("buttonArr"))
        : [],
      fieldUndefined: undefined,
      // 删除告警失败时的错误提示信息
      alarmTipMsg: "",
      // 删除告警成功弹框显隐
      delAlarmSucVisible: false,
      // 删除告警失败弹框显隐
      delAlarmFailVisible: false,
      // 表格加载状态
      alarmloading: false,
      // 删除告警确认弹框显隐
      showdeletesalarmdialog: false,
      // 表格选中行数据
      selectedAlarm: [],
      // 搜索条件
      search: {
        level: "",
        handle: "true",
        search: "",
      },
      brand: {
        0: {
          value: "0",
          label: i18n.t("device.brand0"),
        },
        1: {
          value: "1",
          label: i18n.t("device.brand1"),
        },
        2: {
          value: "2",
          label: i18n.t("device.brand2"),
        },
        3: {
          value: "3",
          label: i18n.t("device.brand3"),
        },
        10: {
          value: "10",
          label: "--",
        },
      },
      // 告警类型选项（警告/错误/故障）
      level: [
        {
          label: this.$t("alarm.warning"),
          value: "0",
          name: "warning",
        },
        {
          label: this.$t("alarm.error"),
          value: "1",
          name: "standby",
        },
        {
          label: this.$t("alarm.fault"),
          value: "2",
          name: "fault",
        },
      ],
      // 告警列表数据
      alarmlist: [],
      // 分页配置
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15,
      },
      // 搜索弹框显隐
      showSearch: false,
      // 当前所选月份
      chartDate: end,
      // 月份选择器配置：含本月快捷选择 + 禁用未来月份
      pickerMonthOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_thismonth') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1)
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
      // 告警详情数据
      checkData: {
        gts: "",
        cts: "",
        handle: {},
        level: 0,
        code: "",
        desc: "",
        brand: 0,
        sn: "",
        deviceSn: "",
        alias: "",
        devaddr: "",
        pn: "",
        usr: "",
      },
      // 告警详情弹框显隐
      showcheckalarmdialog: false,
      // 复制内容临时存储
      infoCopy: String,
      // 导出弹框显隐
      exportDialog: false,
      // 导出弹框表单数据（PN/SN/设备编码/设备地址，均非必填）
      dialogForm: {
        sn: "",
        pn: "",
        devaddr: "",
        devcode: "",
      },
      // 导出弹框日期选择器默认值
      dialogDateValue: end,
      // 导出弹框月份选择器配置
      dialogPickerMonthOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_thismonth') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1)
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
      // 导出任务列表弹框显隐
      exportListDialog: false,
      // 导出任务列表数据
      exportList: [],
      // 导出任务列表分页配置
      dialogPagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15,
      },
      // 导出确认按钮加载状态
      confirmLoading: false,
    };
  },
  mounted() {
    if (this.$route.query.val) {
      this.search.search = this.$route.query.val;
    }
    this.getData();
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
    }),
  },
  watch: {
    "$route.query.val": {
      handler(val) {
        if (val) {
          this.search.search = this.$route.query.val;
          this.getData();
        }
      },
    },
    chartDate () {
      this.getData(true);
    },
    exportDialog(val) {
      if (!val) {
        this.closeExportDialog();
        this.$refs.dateMonthPicker.handleClose();
        document.removeEventListener("click", this.handleDocumentClick, true);
      } else {
        document.addEventListener("click", this.handleDocumentClick, true);
      }
    },
  },
  methods: {
    // 点击外部关闭日期选择器面板
    handleDocumentClick(event) {
      if (!this.$refs.dateMonthPicker.$el.contains(event.target)&&event.target.closest('.select-date1') == null) {
      this.$refs.dateMonthPicker.handleClose();
      }
    },
    // 复制文本到剪贴板
    copy(info) {
      this.infoCopy = info;
      var input = document.createElement("input");
      input.value = this.infoCopy;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      this.$message.success(this.$t("datalogger.copy"));
      document.body.removeChild(input);
    },
    // 打开搜索弹框并聚焦输入框
    showSearchBtn() {
      this.search = {
        level: "",
        handle: "true",
        search: "",
      };
      const end = new Date();
      end.setHours(0, 0, 0, 0);
      // this.chartDate = end;
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 确认搜索
    handleSearch() {
      // this.showSearch = false;
      if(!this.search.search){
         this.showSearch = false;
      }
      this.getData(true);
    },
    // 关闭搜索弹框并重置搜索条件
    closeSearch() {
      this.showSearch = false;
      this.search.search = "";
      this.search.handle = "true";
      const end = new Date();
      end.setHours(0, 0, 0, 0);
      this.chartDate = end;
      this.getData(true);
    },
    // 打开导出弹框（含权限校验）
    exportReportMonth() {
      if (this.disPermissionsLogo && !this.btnList.includes("export_alarm")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.exportDialog = true;
    },
    // 跳转设备详情页
    enterDevice(info) {
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then((res) => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                pid: info.pid,
                tab: "alarm",
              },
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 表格单元格样式回调
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return "deviceName";
      }
    },
    // 查询归档告警列表
    getData(reset) {
      if (reset) this.pagination.currentPage = 1;
      const month = this.chartDate
        ? this.$filter.formatDate(this.chartDate, "yyyyMM")
        : "";
      let param = {
        month,
        level:this.search.level,
        pn:this.search.search,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pagesize,
      };
      this.alarmloading = true;
      this.$request.postMicroserDess("/alm/api/auth/web/warning/archive/query", param).then((res) => {
        if (res.code == 0) {
          res.data.items.forEach((item) => {
            item.handle = item.handle
              ? {
                  label: i18n.t("alarm.processed"),
                  class: "processed",
                }
              : {
                  label: i18n.t("alarm.untreated"),
                  class: "untreated",
                };
            item.gts = item.gts ? this.$filter.formatDate(new Date(item.gts)) : '';
            item.usr = item.uname ? item.uname : '--';
            // 后端返回deviceSn为占位符'--'时视为无效，置空后由模板回退展示sn
            item.deviceSn = item.deviceSn && item.deviceSn !== '--' ? item.deviceSn : '';
          });
          this.alarmlist = res.data.items;
          this.pagination.total = res.data.total;
          this.exportReportMonthLoad = false;
        } else {
          this.alarmlist = [];
          this.pagination.total = 0;
          this.exportReportMonthLoad = true;
        }
        this.alarmloading = false;
      });
    },
    // 关闭删除告警确认弹框
    closeDialog() {
      this.showdeletesalarmdialog = false;
    },
    // 关闭导出弹框并重置表单数据
    closeExportDialog() {
      this.exportDialog = false;
      this.dialogForm = {
        sn: "",
        pn: "",
        devaddr: "",
        devcode: "",
      };
      let end = new Date();
      end.setHours(0, 0, 0, 0);
      this.dialogDateValue = end;
      this.confirmLoading = false;
    },
    // 表格选择行变化回调
    changeFun(val) {
      this.selectedAlarm = val;
    },
    // 打开告警详情弹框（含权限校验）
    checkalarm(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("alarm_details")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.checkData = info;
      this.showcheckalarmdialog = true;
    },
    // 打开删除告警确认弹框（含权限校验）
    detelealarm(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("delete_alarm")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      if (!info.length) return false;
      var PNAll = [];
      info.forEach((item) => {
        PNAll.push(item.id);
      });
      this.pnbox = PNAll;
      this.showdeletesalarmdialog = true;
    },
    // 确认删除归档告警
    configdelete() {
      const month = this.chartDate
        ? this.$filter.formatDate(this.chartDate, "yyyyMM")
        : "";
      this.$request
        .postMicroserDess("/alm/api/auth/web/warning/archive/delete", {
          month,
          id: this.pnbox.join(","),
        })
        .then((res) => {
          if (res.code == 0) {
            this.delAlarmSucVisible = true;
            this.showdeletesalarmdialog = false;
            this.getData();
          } else {
            this.alarmTipMsg = this.$t(`errCode.${res.err || res.code}`);
            this.delAlarmFailVisible = true;
          }
        });
    },
    // 清空表格选中行
    closeBatch() {
      this.$refs.multipleSnTable.clearSelection();
    },
    // 确认导出：提交导出任务并查询导出列表
    confirmClick() {
      if (!this.dialogDateValue) {
        return this.$message.warning(this.$t("report.select_month"));
      }
      this.confirmLoading = true;
      const month = this.$filter.formatDate(this.dialogDateValue, "yyyyMM");
      let param = {
        month,
        sn: this.dialogForm.sn,
        pn: this.dialogForm.pn,
        devaddr: this.dialogForm.devaddr,
        devcode: this.dialogForm.devcode,
      };
      this.$request.postMicroserDess("/alm/api/auth/web/warning/archive/export", param).then((res) => {
        if (res.code == 0) {
          this.dialogPagination.page = 1;
          let params = {
            pagesize: this.dialogPagination.pagesize,
            page: this.dialogPagination.currentPage - 1,
            i18n: this.$lang.currentLang,
          };
          this.$request.get("queryTaskFile", params).then((result) => {
            if (result.err == 0) {
              this.exportList = result.dat.list;
              this.dialogPagination.total = result.dat.total;
              this.exportListDialog = true;
              this.closeExportDialog();
            } else {
              this.exportList = [];
              this.$message.error(this.$t(`errCode.${result.err}`));
            }
          });
          this.confirmLoading = false;
        } else {
          this.$message.error(this.$t(`errCode.${res.err || res.code}`));
        }
        this.confirmLoading = false;
      });
    },
    // 查询导出任务文件列表
    queryExportList(reset) {
      if (reset) this.dialogPagination.currentPage = 1;
      let params = {
        pagesize: this.dialogPagination.pagesize,
        page: this.dialogPagination.currentPage - 1,
      };
      this.$request.get("queryTaskFile", params).then((result) => {
        if (result.err == 0) {
          this.exportList = result.dat.list;
          this.dialogPagination.total = result.dat.total;
          if (reset && reset == 2) {
            this.exportListDialog = true;
          }
        } else {
          this.exportList = [];
          this.$message.warning(this.$t(`errCode.${result.err}`));
        }
      });
    },
    // 下载导出文件
    exportDownLoad(row) {
      let param = {
        action: "downLoadFile",
        i18n: this.$lang.currentLang,
        id: row.id,
      };
      window.open(this.$request.http_download_url_new(param));
    },
    // 切换上一月
    toPreMonth () {
      let aimTime = this.$filter.formatDate1(this.$refs.dateMonth.value, "yyyy-MM-dd");
      let preMonth = this.$tool.getPreMonth(aimTime);
      if (/^\d{4}-\d{2}$/.test(preMonth)) {
        const [y, m] = preMonth.split('-');
        this.chartDate = new Date(Number(y), Number(m) - 1);
      } else {
        this.chartDate = preMonth;
      }
    },
    // 切换下一月
    toNextMonth () {
      let aimTime = this.$filter.formatDate1(this.$refs.dateMonth.value, "yyyy-MM-dd");
      let nextMonth = this.$tool.getNextMonth(aimTime);
      if (new Date(nextMonth) > Date.now()) return this.$message.warning(this.$t("device.noDate"));
      if (/^\d{4}-\d{2}$/.test(nextMonth)) {
        const [y, m] = nextMonth.split('-');
        this.chartDate = new Date(Number(y), Number(m) - 1);
      } else {
        this.chartDate = nextMonth;
      }
    },
    // 返回告警列表页
    goBack() {
      const prefix = this.$route.path.startsWith("/adminNew") ? "/adminNew" : "/generalNew";
      this.$router.push(`${prefix}/alarm`);
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

/* 归档历史页面返回按钮样式 */
.archive-history {
  .search .left .btn-back {
    color: @primaryTextColor;
    background: transparent;
    border: none;
    padding: 0;
    font-size: 14px;
    margin-right: 16px;

    i {
      margin-right: 5px;
    }
  }
}

/* 归档告警主容器：详情弹框样式、按钮样式、主体区域布局 */
.alarmSNew {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  /* 告警详情弹框样式 */
  .checkalarm {
    background-color: rgba(43, 63, 75);
    padding: 24px 20px;
    border-radius: 11px;
    margin-bottom: 20px;

    .alarmdetails {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      color: rgba(255, 255, 255, 0.7);

      .ellipsis-span {
        display: inline-block;
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
    }
  }

  .button-export {
    height: 48px;
    background: @primaryTextColor;
    color: rgb(34, 45, 53);
    font-size: 14px;
    border-radius: 0px;
    border: none;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  overflow: auto;

  /* 主体区域 */
  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    /* 搜索栏样式 */
    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      /* 搜索弹框浮层 */
      .search-alert {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px !important;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: -20px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      /* 月份切换器（日历图标 + 上一月/下一月按钮 + 日期选择器） */
      .datePreNext {
        display: flex;
        align-items: center;
        padding: 0px 16px;
        border-left: 1px solid #7B8395;
        border-right: 1px solid #7B8395;
        margin-right: 16px;

        /deep/.datepicker {
          margin: 0px;
          margin-right: 16px;
        }

        /deep/.el-date-editor.el-input {
          width: 150px;
        }

        /deep/.el-date-editor.el-input .el-input__inner {
          padding: 0px;
          text-align: center;
        }

        /deep/.el-input__prefix {
          display: none;
        }

        /deep/.el-input__suffix {
          top: 2px;
          right: 16px;
        }

        .date-icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../assets/img/general/Icon_Calendar.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
          margin-right: 16px;
        }

        .date-pre {
          background: url(../../assets/img/general/Chart_Date_Pre.png);
        }

        .date-next {
          background: url(../../assets/img/general/Chart_Date_Next.png);
        }

        .date-btn {
          color: #ffffff;
          cursor: pointer;
          display: inline-block;
          height: 16px;
          width: 16px;
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
        }
      }

      /* 左侧搜索区域 */
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-select:not(:last-child),
      /deep/.search .el-input:not(:last-child) {
        margin-right: 0px;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      /* 搜索按钮 */
      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }
    }

    /* 批量操作浮条样式 */
    .batch-alert {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 48px;
      z-index: 1;
      background: rgba(255, 231, 107, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .batch-total {
        padding-left: 16px;
        font-size: 14px;
      }

      .batch-right {
        display: flex;
        justify-content: flex-end;
      }

      .batch-hide {
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .batch-operate {
        display: flex;
        justify-content: flex-end;

        .btn {
          color: rgba(34, 45, 53, 1);
          font-size: 14px;
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          padding: 0px 16px;
          border-radius: 0px;
          display: flex;
          align-items: center;

          &:hover {
            background: rgba(255, 255, 255, 1);
          }
        }

        .ico-copy {
          background: url(../../assets/img/general/Icon_Batch_Copy.png);
        }

        .ico-export {
          background: url(../../assets/img/general/Icon_Batch_Export.png);
        }

        .ico-clear {
          background: url(../../assets/img/general/Icon_Batch_Delete.png);
        }

        .ico-more {
          background: url(../../assets/img/general/Icon_Batch_More.png);
        }

        .ico {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 8px;
        }
      }
    }

    /* 表格加载蒙层样式 */
    .tableloding {
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }
  }
 /* 表格样式 */
 .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /* 下载按钮禁用（文件大小为0）时置灰，避免图标在深色表格上显示为白色 */
      .operation.is-disabled i,
      .operation.is-disabled:hover i,
      .operation.is-disabled:focus i {
        color: @primaryTextColor;
        opacity: 0.35;
        cursor: not-allowed;
      }

      .redirect {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        display: none;
      }

      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
 }
  /* 分页器样式 */
 .tablebottom {

      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          background-color: #2b3842;
          color: #15c491;
        }

        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
 }
  /* 全局滚动条样式 */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #222d35;
  }

  /* 日期范围选择器样式 */
  /deep/.el-range__icon {
    margin-left: 25px;
  }

  /deep/.el-date-editor--daterange {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
  }

  /deep/.el-range-separator {
    color: #fff;
    width: 18%;
    line-height: 48px;
  }

  /* 日历图标样式（全局，替换默认日历图标为自定义图片） */
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 12px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  /* 带下拉箭头的日期选择器样式 */
  .alrm-date {
    /deep/.el-icon-date:before {
      content: "";
    }

    /deep/.el-input__prefix .el-input__icon:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      right: -2px;
      height: 20px;
      width: 20px;
      background: url(../../assets/img/general/Icon_Down_Border.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }
  }

  /* 加载动画样式 */
  .el-loading-spinner .path {
    stroke: @primaryTextColor !important;
  }
}
</style>
<style lang="less">
/* 全局字体设置 */
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  font-family: Microsoft YaHei;
}

/* 日期范围选择器面板样式（暗色主题） */
.select-date1.el-picker-panel {
  background-color: #222d35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222d35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  .in-range {
    background-color: #222d35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-date-table td.in-range {
    background-color: #222d35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff;
  }

  .el-date-table td.disabled div {
    background-color: #222d35 !important;
    color: #606266 !important;
  }
}

/* 设备类型下拉选项样式 */
.select-search-pro {
  width: 200px;
  background: #222d35;
  font-family: Microsoft YaHei;
  border-radius: 6px;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  .el-select-dropdown__wrap {
    max-height: 546px;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__title {
    padding-left: 16px;
    font-size: 14px;
    color: #ffffff;
    border-bottom: 1px solid #424e56;
    line-height: 39px;
    margin-top: 10px;
  }

  .el-select-dropdown__item {
    padding-left: 16px;
    font-size: 14px;
    text-align: left;
    background: #222d35;
    color: #ffffff;
    font-family: Microsoft YaHei;
  }

  .el-select-group__wrap {
    padding-bottom: 0px;
  }

  .el-select-dropdown__item:hover {
    background: #222d35;
    color: #ffffff;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin-right: 5px;
    position: absolute;
    top: 6px;
    right: 12px;
  }
}

/* 表格边框线隐藏 */
.el-table--border:after,
.el-table--group:after {
  display: none;
}

/* 下拉清除按钮图标替换 */
.selectClearNew {
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }
}

/* 月份/日期选择器面板样式（暗色主题） */
.select-date {
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00febb;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00febb;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  .el-date-picker__header--bordered {
    border: none;
  }

  .el-month-table td.today .cell {
    color: #00febb;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7b8395;
  }

  .el-month-table td .cell:hover {
    color: #00febb;
  }

  .el-year-table td.today .cell {
    color: #00febb;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7b8395;
  }

  .el-year-table td .cell:hover {
    color: #00febb;
  }
}

/* 月份选择器面板宽度及布局修正 */
.select-date {
  width: 320px !important;
  padding-top: 10px;

  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}

/* 操作结果弹框样式（成功/失败图标 + 提示文字 + 操作按钮） */
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}

/* 导出弹框表单样式（日期选择器 + 设备输入框） */
.searchDialog {
  align-items: flex-start;

  .search-label {
    margin: 10px 0;
    position: relative;
  }

  .dot::before {
    content: "*";
    color: red;
    position: absolute;
    left: -10px;
  }

  .datepicker {
    margin: 0px;
  }

  .el-date-editor.el-input {
    width: 150px;
  }

  .el-date-editor.el-input .el-input__inner {
    padding: 0px 40px;
    text-align: center;
  }

  .el-input__prefix {
    display: flex;
    align-items: center;
    left: 10px;
  }

  .el-input__prefix .el-input__icon.el-icon-date {
    width: 24px;
    height: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;

    &:before {
      content: "";
      position: static;
      background: none;
    }
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: none !important;
  }

  .dialog-input {
    width: 200px;

    .el-input__inner {
      background: #222d35;
      border: 1px solid #7b8395;
      border-radius: 6px;
      color: #ffffff;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
    }
  }

  .dialog-input .el-input__suffix,
  .dialog-input .el-input__suffix-inner {
    display: flex !important;
    align-items: center;
    color: #7b8395;
  }

  .el-range-editor.el-input__inner {
    width: 100%;
  }

  .el-range-separator {
    line-height: 32px !important;
  }

  .showoperate {
    text-align: right;
  }
}
</style>
